import dashboardPic from "../assets/dashboard.svg";
// import payablePic from "../assets/payable.svg";
import ledgerPic from "../assets/ledger.svg";
import chartPic from "../assets/chart.svg";
import taxPic from "../assets/tax.svg";
import loanPic from "../assets/loan.svg";
import reportPic from "../assets/report.svg";
import projectPic from "../assets/project.svg";
import homePic from "../assets/home.svg";
import availablePic from "../assets/available.svg";
import employeePic from "../assets/employee.svg";
import payrollPic from "../assets/payroll.svg";
import brokerPic from "../assets/broker.svg";
import leadPic from "../assets/lead.svg";
import leadsPic from "../assets/leads.svg";
import taskPic from "../assets/tasks.svg";
import personPic from "../assets/person.svg";
import depriciationPic from "../assets/depriciation.svg";
import maintainPic from "../assets/maintenence.svg";
import assestsPic from "../assets/assets.svg";
import whatsupPic from "../assets/whatsup.svg";
import todolist from "../assets/todolist.svg";
import analytics from "../assets/analytics.png";
export const accountsPathsArr = [
  {
    text: "Dashboard",
    icon: <img src={dashboardPic} alt="Dashboard" className="ml-3 Icondashboard" />,
    url: "/account/dashboard",
    rolename: "Accounts_Dashboard",
  },
  {
    text: "Vouchers",
    icon: <img src={payrollPic} alt="Vouchers" className="ml-3 Iconpayable" />,
    rolename: "Accounts_Vouchers",
    subbtn: [
      {
        text: "Receipts",
        url: "/account/vouchers/receipt-entry/general-receipt",
        rolename: "Vouchers_Receipt",
        route: "receipt-entry",
        subTab: [
          {
            name: "General Receipt",
            url: "/account/vouchers/receipt-entry/general-receipt",
            info: "General ",
            rolename: "Receipt_General Receipt",
            route: "general-receipt",
          },
          {
            name: "Client Receipt",
            url: "/account/vouchers/receipt-entry/client-receipt",
            info: "Client ",
            rolename: "ERP-Receipt_Client_Receipt",
            route: "client-receipt",
          },
          {
            name: "Unit Receipt",
            info: "Unit ",
            url: "/account/vouchers/receipt-entry/unit-receipt",
            rolename: "Receipt_Unit Receipt",
            route: "unit-receipt",
          },
          {
            name: "Deal Sold Receipt",
            info: "Deal Sold ",
            url: "/account/vouchers/receipt-entry/deal-sold-rec",
            rolename: "Receipt_Deal Sold Receipt",
            route: "deal-sold-rec",
          },
          // {
          //   name: "Recovery Receipt",
          //   info: "Recovery ",
          //   url: "/account/vouchers/receipt-entry/recovery-receipt",
          //   rolename: "Receipt_Recovery Receipt",
          //   route: "recovery-receipt",
          // },
          {
            name: "Invest Receipt",
            url: "/account/vouchers/receipt-entry/invest-receipt",
            info: "Invest ",
            rolename: "Receipt_Invest Receipt",
            route: "invest-receipt",
          },
          {
            name: "Commission Receipt",
            url: "/account/vouchers/receipt-entry/com-receipt",
            info: "Commission ",
            rolename: "Receipt_Com Receipt",
            route: "com-receipt",
          },
        ],
      },
      {
        text: "Payments",
        url: "/account/vouchers/payment-entry/general-payment",
        rolename: "Vouchers_Payments",
        route: "payment-entry",
        subTab: [
          {
            name: "General Payment",
            url: "/account/vouchers/payment-entry/general-payment",
            info: "General ",
            rolename: "Payments_General Payment",
            route: "general-payment",
          },
          {
            name: "Purchase Payment",
            url: "/account/vouchers/payment-entry/purchase-payment",
            info: "Purchase",
            rolename: "Payments_General Payment", // same role as General Payment (no new roles)
            route: "purchase-payment",
          },
          {
            name: "Land Payment",
            info: "Land ",
            url: "/account/vouchers/payment-entry/land-payment",
            rolename: "Payments_Land Payment",
            route: "land-payment",
          },
          {
            name: "Salary Payment",
            url: "/account/vouchers/payment-entry/salary-payment",
            info: "Salary ",
            rolename: "Payments_Salary Payment",
            route: "salary-payment",
          },
          {
            name: "Invest Payment",
            url: "/account/vouchers/payment-entry/invest-payment",
            info: "Invest ",
            rolename: "Payments_Investment Payment",
            route: "invest-payment",
          },
          {
            name: "Deal Payment",
            url: "/account/vouchers/payment-entry/deal-payment",
            info: "Deal ",
            rolename: "Payments_Deal Payment",
            route: "deal-payment",
          },
          {
            name: "Developer Payment",
            url: "/account/vouchers/payment-entry/developer-payment",
            info: "Developer",
            rolename: "Developer Payment",
            route: "developer-payment",
          },
          {
            name: "Com Payment",
            url: "/account/vouchers/payment-entry/com-payment",
            info: "Com ",
            rolename: "Payments_Com Payment",
            route: "com-payment",
          },
        ],
      },
      {
        text: "Expenses",
        url: "/account/vouchers/expense-voucher",
        rolename: "Vouchers_Expense",
      },
      {
        text: "PDC",
        url: "/account/vouchers/pdc-entry/pdc-receivable",
        // rolename: "Vouchers_PDC",
        rolename: "ERP-Vouchers_PDC",
        route: "pdc-entry",
        subTab: [
          {
            name: "PDC Receivable",
            info: "PDC Receivable",
            url: "/account/vouchers/pdc-entry/pdc-receivable",
            // rolename: "Vouchers_PDC Receipt",
            rolename: "ERP-PDC_PDC Receivable",
            route: "pdc-receivable",
          },
          {
            name: "PDC Payable",
            info: "PDC Payable",
            url: "/account/vouchers/pdc-entry/pdc-payable",
            // rolename: "Vouchers_PDC Payable",
            rolename: "ERP-PDC_PDC Payable",
            route: "pdc-payable",
          },
        ],
      },
      {
        text: "Refunds",
        url: "/account/vouchers/refund-voucher",
        rolename: "Vouchers_Refunds",
      },
      // {
      //   text: "Recovery Booking",
      //   url: "/account/vouchers/recovery-booking",
      //   rolename: "Recovery Booking",
      // },

      {
        text: "Journal Entry",
        url: "/account/vouchers/journal-entry",
        rolename: "Vouchers_Journal Entry",
      },
      {
        text: "Adjustments",
        url: "/account/vouchers/general-adjustment",
        rolename: "Vouchers_Adjustments",
      },

      // {
      //   text: "Installments",
      //   url: "/account/vouchers/installments/receipt-installments",
      //   rolename: "Vouchers_Installments",
      //   route: "installments",
      //   subTab: [
      //     {
      //       name: "Receipt Installments",
      //       url: "/account/vouchers/installments/receipt-installments",
      //       info: "Receipt Installments",
      //       rolename: "Installments_Receipt Installments",
      //       route: "receipt-installments",
      //     },
      //     {
      //       name: "Payment Installments",
      //       url: "/account/vouchers/installments/payment-installments",
      //       info: "Payment Installments",
      //       rolename: "Installments_Payment Installments",
      //       route: "payment-installments",
      //     },
      //   ],
      // },
      // {
      //   text: "External Comm",
      //   url: "/account/vouchers/external-commission/income",
      //   rolename: "Vouchers_External Comm",
      //   route: "external-commission",
      //   subTab: [
      //     {
      //       name: "Income",
      //       url: "/account/vouchers/external-commission/income",
      //       info: "Income",
      //       rolename: "External Comm_Income",
      //       route: "income",
      //     },
      //     {
      //       name: "Expense",
      //       url: "/account/vouchers/external-commission/expense",
      //       info: "Expense",
      //       rolename: "External Comm_Expense",
      //       route: "expense",
      //     },
      //   ],
      // },
      {
        text: "Draft Vouch",
        url: "/account/vouchers/unsubmitted-vouchers",
        rolename: "Vouchers_Draft Vouch",
      },
      {
        text: "Saved Vouch",
        url: "/account/vouchers/submitted-vouchers",
        rolename: "Vouchers_Saved Vouch",
      },
      // {
      //   text: "Notifications",
      //   url: "/account/vouchers/notifications",
      //   rolename: "Vouchers_Notifications",
      // },
    ],
  },
  {
    text: "Chart of Acc.",
    icon: <img src={chartPic} alt="Chart" className="ml-3 Iconpayable" />,
    rolename: "Accounts_Chart Of Acc",
    subbtn: [
      {
        text: "Chart of Acc",
        url: "/account/chart-of-acc/Chart",
        rolename: "Chart Of Acc_View",
      },
      {
        text: "Heading",
        url: "/account/chart-of-acc/heading",
        rolename: "ERP-Chart Of Acc_Heading",
        // Per project like Account: the Main Chart is built from project headings, so
        // a heading added without a project would not show up in it.
        requiresProject: true,
      },
      {
        text: "Account",
        url: "/account/chart-of-acc/account",
        rolename: "Chart Of Acc_Account",
        // Single-account management is per-project only, not supported in Main Chart of
        // Account (all-projects) mode — hidden from the sidebar there, same as Reports/Vouchers.
        requiresProject: true,
      },
      {
        text: "Banks",
        url: "/account/chart-of-acc/banks",
        rolename: "ERP-Chart Of Acc_Bank",
        // Banks are per project — each project keeps its own chart of accounts, so a
        // bank's GL account belongs to one project. Hidden in all-projects mode for the
        // same reason Account is.
        requiresProject: true,
      },
    ],
  },
  {
    text: "Tax",
    icon: <img src={taxPic} alt="Tax" className="ml-3 Icontax" />,
    rolename: "Accounts_Tax",
    subbtn: [
      {
        text: "Tax",
        url: "/account/tax/Tax",
        rolename: "Tax_Tax",
      },
      {
        text: "Tax Payable",
        url: "/account/tax/tax-payable",
        rolename: "Tax_Tax Payable",
      },
      {
        text: "Tax Receivable",
        url: "/account/tax/tax-receivable",
        rolename: "Tax_Tax Receivable",
      },
    ],
  },
  {
    text: "Investment",
    icon: <img src={loanPic} alt="Investment" className="ml-3 Iconhome" />,
    rolename: "Accounts_Investment",
    subbtn: [
      {
        text: "Investor",
        url: "/account/investment/Investor",
        rolename: "Investment_Investor",
      },
      {
        text: "Investment",
        url: "/account/investment/Investment",
        rolename: "Investment_Investment",
      },
      // Investment Receipts/Settlements are reached via Vouchers > Receipts > "Invest Receipt"
      // and Vouchers > Payments > "Invest Payment" — those entries now point at the new
      // Investment module's list pages, so no separate sidebar entry is needed here.
    ],
  },
  {
    text: "Reports",
    icon: <img src={reportPic} alt="Reports" className="ml-3 Iconpayable" />,
    rolename: "Accounts_Reports",
    // NOTE: most report endpoints under this menu don't correctly aggregate "all projects"
    // yet (they either 404/return nothing, or leak other businesses' data — see the
    // 2026-session backend audit). Each item below is marked `requiresProject: true` unless
    // confirmed safe, and Layout.js hides `requiresProject` items from this list while the
    // user is in Main Chart of Account mode (no specific project selected). Remove the flag
    // from an item once its backend endpoint is fixed to use Shared.ProjectScope correctly.
    subbtn: [
      {
        text: "Trail Blnc",
        url: "/account/reports/trail-balance",
        rolename: "Reports_Trail Balance",
        // Safe: TrialBalanceReport now merges every real project's headings/accounts by
        // title and sums live Transaction balances when no project is selected.
      },
      {
        text: "Cost Center",
        url: "/account/reports/cost-center",
        rolename: "Reports_Cost Center",
        requiresProject: true,
      },
      {
        text: "Journal",
        url: "/account/reports/general-journal",
        rolename: "Reports_General Journal",
        requiresProject: true,
      },
      {
        text: "Ledger",
        url: "/account/reports/general-ledger",
        rolename: "Reports_General Ledger",
        // Safe: GeneralLedger consolidates every real project's same-titled account (by
        // heading + account title) when no project is selected, optionally narrowed by the
        // Select Project checkboxes, with opening balance and period rows from the same data.
      },
      {
        text: "Land Inst. Trac",
        url: "/account/reports/land-installment-tracker",
        rolename: "Reports_Land Installment Tracker",
        // Safe: this endpoint was never project-scoped, it already sums the whole business.
      },
      {
        text: "Cancelled Plots",
        url: "/account/reports/cancelled-plots",
        rolename: "Reports_Cancelled Plots",
        requiresProject: true,
      },
      {
        text: "Deleted Vouchs",
        url: "/account/reports/deleted-vouchers",
        rolename: "Reports_Deleted Vouchers",
        requiresProject: true,
      },
      {
        text: "Balance Sheet",
        url: "/account/reports/balance-sheet",
        rolename: "Reports_Balance Sheet",
        // Safe: BalanceSheet(LedgerInput) now merges every real project's headings/accounts
        // by title and sums live Transaction balances when no project is selected (also
        // fixed a cross-tenant BusinessId scoping gap while auditing this endpoint).
      },
      {
        text: "Income State",
        url: "/account/reports/income-statement",
        rolename: "Reports_Income Statement",
        // Safe: ProfitandLoss(LedgerInput) now merges every real project's headings/accounts
        // by title and sums live Transaction balances when no project is selected (also
        // fixed a cross-tenant BusinessId scoping gap, and a frontend bug that called the
        // wrong endpoint entirely when no project was selected).
      },
      {
        text: "Cash Book",
        url: "/account/reports/cash-book",
        rolename: "Reports_Cash Book",
        // Safe: CashBook resolves its accounts through Shared.ProjectScope, so with no
        // project selected it covers every project rather than the business-level rows.
      },
      {
        text: "Bank Book",
        url: "/account/reports/bank-book",
        rolename: "Reports_Bank Book",
        // Safe for the same reason as the Cash Book above — one shared implementation.
      },
      {
        text: "Manager Recov",
        url: "/account/reports/manager-recovery",
        rolename: "Reports_Manager Recovery",
        requiresProject: true,
      },
      // {
      //   text: "Recov Receipt",
      //   url: "/account/reports/recovery-receipt",
      //   rolename: "Reports_Recovery Receipt",
      //   requiresProject: true,
      // },

      {
        text: "Acc Receivable",
        url: "/account/reports/account-receivable",
        rolename: "Reports_Account Receivable",
        requiresProject: true,
      },
      {
        text: "Acc Payable",
        url: "/account/reports/account-payable",
        rolename: "Reports_Account Payable",
        requiresProject: true,
      },
      {
        text: "AR Aging Detail",
        url: "/account/reports/account-receivable-aging-details",
        rolename: "Reports_Account Receivable Aging",
        requiresProject: true,
      },
      {
        text: "AP Aging Detail",
        url: "/account/reports/account-payable-aging-details",
        rolename: "Reports_Account Payable Aging",
        requiresProject: true,
      },
      {
        text: "AR Aging Summary",
        url: "/account/reports/account-receivable-aging-summary",
        rolename: "Reports_Account Receivable Aging Summary",
        requiresProject: true,
      },
      {
        text: "AP Aging Summary",
        url: "/account/reports/account-payable-aging-summary",
        rolename: "Reports_Account Payable Aging Summary",
        requiresProject: true,
      },
      {
        text: "Install Receipt",
        url: "/account/reports/install-receipt",
        rolename: "Reports_Install Receipt",
        requiresProject: true,
      },
      {
        text: "Install Payment",
        url: "/account/reports/install-payment",
        rolename: "Reports_Install Payment",
        requiresProject: true,
      },
      {
        text: "Comm Pay",
        url: "/account/reports/commission-payment",
        rolename: "Reports_Commission Payment",
        requiresProject: true,
      },
      {
        text: "Comm Receipt",
        url: "/account/reports/commission-receipt",
        rolename: "Reports_Commission Receipt",
        requiresProject: true,
      },
      {
        text: "Admin Pay",
        url: "/account/reports/admin-share-payable",
        rolename: "Reports_Admin Share Payable",
        requiresProject: true,
      },
      {
        text: `Res Comm Pay`,
        url: "/account/reports/reserved-commission-payable",
        rolename: "Reports_Reserved Commission Payable",
        requiresProject: true,
      },
      {
        text: "Project Report",
        url: "/account/reports/project-report",
        rolename: "Reports_Project Report",
        requiresProject: true,
      },
      {
        text: "Refund Summary",
        url: "/account/reports/repurchased-units-summary",
        rolename: "Reports_Refund Summary",
        requiresProject: true,
      },
    ],
  },
  {
    text: "Analytics",
    icon: <img src={analytics} alt="Investment" className="ml-3 Iconhome" />,
    rolename: "ERP-Accounts_Analytics",
    subbtn: [
      {
        text: "Executive Overview",
        url: "/account/analytics/executive-overview",
        rolename: "ERP-Analytics_Executive Overview",
      },
      {
        text: "Cash Flow",
        url: "/account/analytics/cash-flow",
        rolename: "ERP-Analytics_Cash Flow",
      },
      {
        text: "Project Cost",
        url: "/account/analytics/project-cost",
        rolename: "ERP-Analytics_Project Cost",
      },
      {
        text: "Sales Recovery",
        url: "/account/analytics/sales-recovery",
        rolename: "ERP-Analytics_Sales Recovery",
      },
      {
        text: "Profitability",
        url: "/account/analytics/profitability",
        rolename: "ERP-Analytics_Profitability",
      },
    ],
  },
];
export const contractArray = [
  {
    text: "Dashboard",
    icon: <img src={dashboardPic} alt="Dashboard" className="ml-3 mr-1  Icondashboard" />,
    url: "/contract/dashboard",
    rolename: "ERP-Contract_Dashboard",
  },
  {
    text: "Contracts",
    icon: <img src={ledgerPic} alt="Ledger" className="ml-3 mr-1 Iconpayable" />,
    rolename: "Contract_Contracts",
    url: "/contract/contracts/with-unit",
    subbtn: [
      {
        text: "Unit Contract",
        url: "/contract/contracts/with-unit",
        rolename: "Contracts_Contract With Unit",
        route: "with-unit",
      },
      {
        text: "File Contract",
        url: "/contract/contracts/without-unit",
        rolename: "Contracts_Contract Without Unit",
        route: "without-unit",
      },
      {
        text: "Payment Plan",
        url: "/contract/contracts/payment-plan",
        rolename: "ERP-Contracts_Payment Plan",
        route: "payment-plan",
      },
    ],
  },
  {
    text: "Install Resch",
    icon: <img src={chartPic} alt="Dashboard" className="ml-3 mr-1 Icondashboard" />,
    url: "/contract/install-reschedule",
    rolename: "Contract_Install Resch",
  },
  {
    text: "Ballot",
    icon: <img src={brokerPic} alt="Dashboard" className="ml-3 Iconbroker" />,
    url: "/contract/ballot",
    rolename: "Contract_Ballot",
  },
  {
    text: "Customers",
    icon: <img src={leadPic} alt="Dashboard" className="ml-3 Iconbroker" />,
    url: "/contract/customers",
    rolename: "Contract_Customers",
  },
  {
    text: "Affiliates",
    icon: <img src={personPic} alt="Dashboard" className="ml-3 mr-1 Icondashboard" />,
    url: "/contract/affiliates",
    rolename: "Contract_Affiliates",
  },
  {
    text: "Trans Contract",
    icon: <img src={loanPic} alt="Dashboard" className="ml-3 mr-1 Icondashboard" />,
    url: "/contract/transfer-contract",
    rolename: "Contract_Trans Contract",
  },
  {
    text: "Transfer Unit",
    icon: <img src={homePic} alt="Dashboard" className="ml-3 Iconbroker" />,
    url: "/contract/transfer-unit",
    rolename: "Contract_Transfer Unit",
  },
  {
    text: "Reports",
    icon: <img src={reportPic} alt="Reports" className="ml-3 mr-1 Iconpayable" />,
    url: "/contract/reports/units",
    rolename: "Contract_Reports",
    subbtn: [
      {
        text: "Units",
        url: "/contract/reports/units",
        rolename: "Reports_Units",
      },
      {
        text: "Customers",
        url: "/contract/reports/customer",
        rolename: "Reports_Customer",
      },
      {
        text: "Affiliate Leaderboard",
        url: "/contract/reports/affiliate-leaderboard",
        rolename: "ERP-Reports_Affiliate Leaderboard",
      },
      {
        text: "Affiliate Commission",
        url: "/contract/reports/affiliate-commission",
        rolename: "ERP-Reports_Affiliate Commission",
      },
    ],
  },
  {
    text: "Settings",
    icon: <img src={projectPic} alt="Settings" className="ml-3 mr-1 Iconpayable" />,
    url: "/contract/settings/commission",
    rolename: "Contract_Affiliates",
    subbtn: [
      {
        text: "Commission Configuration",
        url: "/contract/settings/commission",
        rolename: "Contract_Affiliates",
      },
    ],
  },
];
export const salesArray = contractArray;
export const propertyManagementArray = [
  {
    text: "Dashboard",
    icon: <img src={dashboardPic} alt="Dashboard" className="ml-3 mr-1  Icondashboard" />,
    url: "/property-management/dashboard",
    rolename: "Property Management_Dashboard",
  },
  {
    text: "Units",
    icon: <img src={homePic} alt="Units" className="ml-3 mr-1 Iconhome" />,
    url: "/property-management/units",
    rolename: "ERP-Property Management_Units",
    route: "property-management/units",
  },
  {
    text: "Billing",
    icon: <img src={ledgerPic} alt="Ledger" className="ml-3  mr-1 Iconpayable" />,
    rolename: "Property Management_Billing",
    url: "/property-management/billing/invoice-batches",
    subbtn: [
      {
        text: "Invoice Batches",
        url: "/property-management/billing/invoice-batches",
        rolename: "Billing_Invoice Batches",
        route: "invoice-batches",
      },
      {
        text: "Unit Invoices",
        url: "/property-management/billing/unit-invoices",
        rolename: "Billing_Unit Invoices",
        route: "unit-invoices",
      },
      {
        text: "Void Invoices",
        url: "/property-management/billing/void-invoices",
        rolename: "Billing_Void Invoices",
        route: "void-invoices",
      },
      {
        text: "Invoice Receipts",
        url: "/property-management/billing/invoice-receipts",
        rolename: "Billing_Invoice Receipts",
        route: "invoice-receipts",
      },
    ],
  },
  {
    text: "Charge Heads",
    icon: <img src={payrollPic} alt="Ledger" className="ml-3 Iconhome" />,
    url: "/property-management/charge-heads",
    rolename: "Property Management_Charge Head",
  },
];
// rolename values match screen.role_name built by
// erp-backend/Gravity_Solutions/Migrations/RebuildRegistryScreens.sql, which mirrors
// this array — the groups below are screens too, so unticking one hides its menu.
export const registryArray = [
  {
    text: "Dashboard",
    icon: <img src={dashboardPic} alt="Dashboard" className="ml-3 mr-1 Icondashboard" />,
    url: "/registry/dashboard",
    rolename: "Registry",
  },
  {
    text: "Cases",
    icon: <img src={homePic} alt="Cases" className="ml-3 mr-1 Iconhome" />,
    url: "/registry/cases",
    rolename: "Registry Cases_View",
  },
  {
    text: "Accounts",
    icon: <img src={ledgerPic} alt="Accounts" className="ml-3 mr-1 Iconpayable" />,
    // lands on the first child, as the other menus do
    url: "/registry/receipts/general",
    // the group's own role, so unticking Accounts in the permission tree actually
    // removes the menu — the screen tree has a node for it
    rolename: "Registry_Accounts",
    subbtn: [
      // Layout.js highlights a tab with currentUrl.includes(route), so no two routes
      // here may be a prefix of one another — that is what made a single click light
      // up several tabs. Receipt and Payment own the shared segment; their children
      // carry the full distinguishing path.
      // One sidebar entry per pair; Layout renders subTab as the tab strip above the
      // grid, exactly as it does for the Accounts vouchers — and picks the two-tab
      // button widths itself when a strip has fewer than three tabs.
      {
        text: "Receipt",
        url: "/registry/receipts/general",
        rolename: "Registry Receipt_View",
        route: "receipts",
        subTab: [
          {
            name: "General Receipt",
            info: "General Receipt",
            url: "/registry/receipts/general",
            rolename: "Registry General Receipt_View",
            route: "receipts/general",
          },
          {
            name: "Case Receipt",
            info: "Case Receipt",
            url: "/registry/receipts/case",
            rolename: "Registry Receipt_View",
            route: "receipts/case",
          },
        ],
      },
      {
        text: "Payment",
        url: "/registry/payments/general",
        rolename: "Registry Payment_View",
        route: "payments",
        subTab: [
          {
            name: "General Payment",
            info: "General Payment",
            url: "/registry/payments/general",
            rolename: "Registry General Payment_View",
            route: "payments/general",
          },
          {
            name: "Case Payment",
            info: "Case Payment",
            url: "/registry/payments/case",
            rolename: "Registry Payment_View",
            route: "payments/case",
          },
        ],
      },
      {
        text: "Journal Entry",
        url: "/registry/coa/journal-entry",
        rolename: "Registry Journal Entry_View",
        route: "journal-entry",
      },
      {
        text: "Heading",
        url: "/registry/coa/heading",
        rolename: "Registry Accounts_Create",
        route: "coa/heading",
      },
      {
        text: "Account",
        url: "/registry/coa/add",
        rolename: "Registry Accounts_Create",
        route: "coa/add",
      },
      {
        text: "Banks",
        url: "/registry/coa/banks",
        rolename: "Registry Banks_View",
        route: "coa/banks",
      },
      {
        text: "Chart of Account",
        url: "/registry/coa/chart",
        rolename: "Registry Chart Of Account_View",
        route: "coa/chart",
      },
    ],
  },
  {
    text: "Vendors",
    icon: <img src={personPic} alt="Vendors" className="ml-3 mr-1 Iconhome" />,
    url: "/registry/vendors",
    rolename: "Registry Vendors_View",
  },
  {
    text: "Reports",
    icon: <img src={reportPic} alt="Reports" className="ml-3 mr-1 Iconpayable" />,
    url: "/registry/reports/trial-balance",
    rolename: "Registry_Reports",
    subbtn: [
      {
        text: "Trial Balance",
        url: "/registry/reports/trial-balance",
        rolename: "Registry Reports_Trial Balance",
        route: "trial-balance",
      },
      {
        text: "Balance Sheet",
        url: "/registry/reports/balance-sheet",
        rolename: "Registry Reports_Balance Sheet",
        route: "balance-sheet",
      },
      {
        text: "Income Statement",
        url: "/registry/reports/income-statement",
        rolename: "Registry Reports_Income Statement",
        route: "income-statement",
      },
      {
        text: "Cash Book",
        url: "/registry/reports/cash-book",
        rolename: "Registry Reports_Cash Book",
        route: "cash-book",
      },
      {
        text: "Bank Book",
        url: "/registry/reports/bank-book",
        rolename: "Registry Reports_Bank Book",
        route: "bank-book",
      },
      {
        text: "Ledger",
        url: "/registry/reports/ledger",
        rolename: "Registry Reports_Ledger",
        route: "ledger",
      },
      {
        text: "Project History",
        url: "/registry/reports/project-history",
        rolename: "Registry Reports_Project History",
        route: "project-history",
      },
      {
        text: "Unit History",
        url: "/registry/reports/unit-history",
        rolename: "Registry Reports_Unit History",
        route: "unit-history",
      },
      {
        text: "Customer History",
        url: "/registry/reports/customer-history",
        rolename: "Registry Reports_Customer History",
        route: "customer-history",
      },
    ],
  },
  {
    text: "Settings",
    icon: <img src={maintainPic} alt="Settings" className="ml-3 mr-1 Iconhome" />,
    url: "/registry/charge-heads",
    rolename: "Registry_Settings",
    subbtn: [
      {
        text: "Charge Heads",
        url: "/registry/charge-heads",
        rolename: "Registry Charge Heads_View",
        route: "charge-heads",
      },
      {
        text: "Process Stages",
        url: "/registry/process-stages",
        rolename: "Registry Process Stages_View",
        route: "process-stages",
      },
    ],
  },
];
export const userPortalArray = [
  {
    text: "Dashboard",
    icon: <img src={dashboardPic} alt="Dashboard" className="ml-3 Icondashboard" />,
    url: "/user/dashboard",
    rolename: "CustomerPortal",
  },
  {
    text: "Contracts",
    icon: <img src={ledgerPic} alt="Ledger" className="ml-3 Iconpayable" />,
    url: "/user/contracts",
    rolename: "CustomerPortal",
  },
  {
    text: "Reports",
    icon: <img src={reportPic} alt="Reports" className="ml-3 Iconpayable" />,
    url: "/user/reports/installments",
    rolename: "CustomerPortal",
    subbtn: [
      {
        text: "Installments",
        url: "/user/reports/installments",
        rolename: "CustomerPortal",
      },
      {
        text: "Payments",
        url: "/user/reports/payments",
        rolename: "CustomerPortal",
      },
    ],
  },
  {
    text: "Profile",
    icon: <img src={personPic} alt="Reports" className="ml-3 Iconpayable" />,
    url: "/user/profile/user-info",
    rolename: "CustomerPortal",
    subbtn: [
      {
        text: "User Info",
        url: "/user/profile/user-info",
        rolename: "CustomerPortal",
      },
      {
        text: "Password",
        url: "/user/profile/password",
        rolename: "CustomerPortal",
      },
    ],
  },
];
export const inventoryArray = [
  {
    text: "Dashboard",
    icon: <img src={dashboardPic} alt="Dashboard" className="ml-3 mr-1 Icondashboard" />,
    url: "/inventory/dashboard",
    rolename: "ERP Inventory_Dashboard",
  },
  {
    text: "Projects",
    icon: <img src={projectPic} alt="Dashboard" className="ml-3 mr-1 Icondashboard" />,
    // url: "/inventory/projects",
    rolename: "ERP Inventory_Projects",
    subbtn: [
      {
        text: "Project",
        url: "/inventory/projects/Projects",
        rolename: "ERP-Projects_Project",
      },
      {
        text: "Section",
        url: "/inventory/projects/section",
        rolename: "ERP-Projects_Section",
      },
      {
        text: "Units",
        url: "/inventory/projects/units",
        rolename: "Projects_Units",
      },
      {
        text: "New Purchase",
        url: "/inventory/projects/newpurchase",
        rolename: "ERP-Projects_New Purchase",
      },
      {
        text: "Re Purchase",
        url: "/inventory/projects/repurchase",
        rolename: "Projects_RePuchase",
      },
      // {
      //   text: "Print Temp.",
      //   url: "/inventory/projects/prints",
      //   rolename: "Projects_RePuchase",
      // },
    ],
  },
  {
    text: "Deals",
    icon: <img src={assestsPic} alt="Dashboard" className="ml-3 Iconbroker" />,
    rolename: "ERP Inventory_Deals",
    subbtn: [
      {
        text: "Deal Bought",
        url: "/inventory/deals/dealbought",
        rolename: "Deals_Deal Bought",
      },
      {
        text: "Deal Sold",
        url: "/inventory/deals/dealsold",
        rolename: "Deals_Deal Sold",
      },
      {
        text: "Seller",
        url: "/inventory/deals/sellers",
        rolename: "Deals_Seller",
      },
      // {
      //   text: "Affiliates",
      //   url: "/inventory/deals/affiliates",
      //   rolename: "Deals_ERP Affiliates",
      // },
    ],
  },
  {
    text: "Availability",
    icon: <img src={availablePic} alt="Dashboard" className="ml-3 mr-1 Iconhome" />,
    rolename: "ERP Inventory_Availability",
    subbtn: [
      {
        text: "Availability",
        url: "/inventory/availability/availability",
        rolename: "Availability_Availability",
      },
      // {
      //   text: "Booked Units",
      //   url: "/inventory/availability/booked-units",
      //   rolename: "Availability_Booked Units",
      // },
    ],
  },
  // {
  //   text: "Availability",
  //   icon: (
  //     <img src={availablePic} alt="Dashboard" className="ml-3 Icondashboard" />
  //   ),
  //   url: "/inventory/availability",
  //   rolename: "Inventory Availability",
  // },
  {
    text: "Land & Seller",
    icon: <img src={homePic} alt="Dashboard" className="ml-3 Iconbroker" />,
    rolename: "ERP Inventory_Land & Seller",
    subbtn: [
      {
        text: "Land Deals",
        url: "/inventory/land-and-seller/land-deals",
        rolename: "Land & Seller_Land",
      },
      {
        text: "Land Records",
        url: "/inventory/land-and-seller/land",
        rolename: "Land & Seller_Land",
      },
      {
        text: "Land Seller",
        url: "/inventory/land-and-seller/sellerland",
        rolename: "Land & Seller_Land Seller",
      },
      // {
      //   text: "Seller",
      //   url: "/inventory/land-and-seller/sellers",
      //   rolename: "Land & Seller_Seller",
      // },
    ],
  },
];
export const hrArray = [
  {
    text: "Dashboard",
    icon: <img src={dashboardPic} alt="Dashboard" className="ml-3 mr-1 Icondashboard" />,
    url: "/hr/dashboard",
    rolename: "ERP-Human Resource_Dashboard",
  },
  {
    text: "Attendence",
    icon: <img src={leadPic} alt="Dashboard" className="ml-3 Iconbroker" />,
    rolename: "Human Resource_Attendence",
    subbtn: [
      {
        text: "Attendence",
        url: "/hr/attendence",
        rolename: "Human Resource_Attendence",
      },
    ],
  },
  {
    text: "Payroll",
    icon: <img src={payrollPic} alt="Dashboard" className="ml-3 mr-1 Iconhome" />,
    url: "/hr/payroll",
    rolename: "Human Resource_Payroll",
    subbtn: [
      {
        text: "Assign Salary",
        url: "/hr/payroll/assignsalary",
        rolename: "Payroll_Assign Salary",
      },
      {
        text: "Advance/Loan",
        url: "/hr/payroll/advanceloan/advance-table",
        rolename: "Payroll_Advance/Loan",
        route: "advanceloan",
        subTab: [
          {
            name: "Advance",
            url: "/hr/payroll/advanceloan/advance-table",
            info: "Advance",
            route: "advance-table",
            rolename: "Advance/Loan_Advance",
          },
          {
            name: "Loan",
            info: "Loan",
            url: "/hr/payroll/advanceloan/loan-table",
            route: "loan-table",
            rolename: "Advance/Loan_Loan",
          },
        ],
      },
      {
        text: "Pay Slip",
        url: "/hr/payroll/payslip",
        rolename: "Payroll_Pay Slip",
      },
    ],
  },
  {
    text: "Employees",
    icon: <img src={employeePic} alt="Dashboard" className="ml-3 mr-1  Iconhome" />,
    rolename: "Human Resource_Employees",
    subbtn: [
      {
        text: "Employee",
        url: "/hr/employees/employee",
        rolename: "Employees_Employee",
      },
      {
        text: "Designation",
        url: "/hr/employees/designation",
        rolename: "Employees_Designation",
      },
    ],
  },
];
export const crmArray = [
  {
    text: "Dashboard",
    icon: <img src={dashboardPic} alt="Dashboard" className="ml-3 Icondashboard" />,
    url: "/crm/dashboard",
    rolename: "CRM Dashboard",
  },
  {
    text: "Leads",
    icon: <img src={leadPic} alt="Dashboard" className="ml-3 Icondashboard" />,
    rolename: "Leads",
    subbtn: [
      {
        text: "Leads",
        url: "/crm/leads",
        rolename: "Leads",
      },
    ],
  },
  {
    text: "Clients",
    icon: <img src={personPic} alt="Dashboard" className="ml-3 Icondashboard" />,
    rolename: "Clients",
    subbtn: [
      {
        text: "Clients",
        url: "/crm/client/clients",
        rolename: "Clients",
      },
    ],
  },
  {
    text: "Tasks",
    icon: <img src={taskPic} alt="Dashboard" className="ml-3 Icondashboard" />,
    rolename: "Tasks",
    subbtn: [
      {
        text: "Meeting",
        url: "/crm/tasks/meeting",
        rolename: "Meeting",
      },
      {
        text: "Call",
        url: "/crm/tasks/call",
        rolename: "Call",
      },
      {
        text: "Other Tasks",
        url: "/crm/tasks/othertask",
        rolename: "Other Task",
      },
    ],
  },
  {
    text: "Teams",
    icon: <img src={brokerPic} alt="Dashboard" className="ml-3 Icondashboard" />,
    rolename: "Teams",
    subbtn: [
      {
        text: "Teams",
        url: "/crm/teams/teams",
        rolename: "Add Team",
      },
      {
        text: "Member",
        url: "/crm/teams/member",
        rolename: "Member",
      },
      {
        text: "Hierarchy",
        url: "/crm/teams/hierarchy",
        rolename: "Hierarchy",
      },
    ],
  },
  {
    text: "Availability",
    icon: <img src={availablePic} alt="Dashboard" className="ml-3 Icondashboard" />,
    // url: "/crm/availability",
    rolename: "Crm Availability",
    subbtn: [
      {
        text: "Availability",
        url: "/crm/availability/availability",
        rolename: "Crm Availability",
      },
      {
        text: "Booked Units",
        url: "/crm/availability/units",
        rolename: "Crm Units",
      },
    ],
  },
];
export const assetsArray = [
  {
    text: "Dashboard",
    icon: <img src={dashboardPic} alt="Dashboard" className="ml-3 Icondashboard" />,
    url: "/asset/dashboard",
    rolename: "Asset Dashboard",
  },
  {
    text: "Assets",
    icon: <img src={assestsPic} alt="Dashboard" className="ml-3 Icondashboard" />,
    rolename: "Assets",
    subbtn: [
      {
        text: "Asset",
        url: "/assets/asset",
        rolename: "Add Asset",
      },
      {
        text: "Sell",
        url: "/assets/sale",
        rolename: "Sell",
      },
      {
        text: "Buyer",
        url: "/assets/buyer",
        rolename: "Buyer",
      },
      {
        text: "Seller",
        url: "/assets/seller",
        rolename: "Seller",
      },
    ],
  },
  {
    text: "Maintainance",
    icon: <img src={maintainPic} alt="Dashboard" className="ml-3 Icondashboard" />,
    url: "/asset/maintainance",
    rolename: "Maintainance",
  },
  {
    text: "Depriciation",
    icon: <img src={depriciationPic} alt="Dashboard" className="ml-3 Icondashboard" />,
    url: "/asset/depriciation",
    rolename: "Depriciation",
  },
];

export const settingsPathArr = [
  {
    text: "Profile",
    icon: <img src={personPic} alt="Reports" className="ml-3 Iconpayable" />,
    url: "/settings/profile/personal",
    rolename: "Settings_Profile",
    subbtn: [
      {
        text: "Personal Profile",
        url: "/settings/profile/personal",
        rolename: "ERP-Profile_Personal Profile",
      },
      {
        text: "Business Profile",
        url: "/settings/profile/business",
        rolename: "ERP-Profile_Business Profile",
      },
    ],
  },
  {
    text: "Users",
    icon: <img src={leadPic} alt="Users" className="ml-3 Icondashboard" />,
    url: "/settings/users",
    rolename: "Settings_Users",
  },
  {
    text: "Roles",
    icon: <img src={leadsPic} alt="Roles" className="ml-3 Icondashboard" />,
    url: "/settings/roles",
    rolename: "Settings_Roles",
  },
  {
    text: "Approvals",
    icon: <img src={taskPic} alt="Approvals" className="ml-3 Icondashboard" />,
    url: "/settings/approvals",
    rolename: "ERP-Settings_Approvals",
  },
  {
    text: "Tags",
    icon: <img src={todolist} alt="Tags" className="ml-3 Icondashboard" />,
    url: "/settings/tags",
    rolename: "Settings_Tags",
  },
  // {
  //   text: "Change Request",
  //   icon: (
  //     <img src={reportPic} alt="ChangeRequest" className="ml-3 Icondashboard" />
  //   ),
  //   url: "/settings/change-request",
  //   rolename: "Settings_Change Request",
  // },
  {
    url: "/settings/whatsapp/instances",
    text: "WhatsApp",
    icon: <img src={whatsupPic} alt="WhatsApp" className="ml-3 Icondashboard" />,
    rolename: "Settings_WhatsApp",
    subbtn: [
      {
        text: "Instances",
        // text: "Connect Whatsapp",
        url: "/settings/whatsapp/instances",
        rolename: "WhatsApp_Connect",
      },
      {
        text: "Send Message",
        url: "/settings/whatsapp/wa-send-message",
        rolename: "WhatsApp_Send Message",
      },
      {
        text: "Whatsapp History",
        url: "/settings/whatsapp/wa-history",
        rolename: "WhatsApp_History",
      },
      // {
      //   text: "Whatsapp Templates",
      //   url: "/settings/whatsapp/wa-templates",
      //   rolename: "WhatsApp_History",
      // },
    ],
  },
  {
    text: "Automation",
    icon: <img src={reportPic} alt="Reports" className="ml-3 Iconpayable" />,
    url: "/settings/automation",
    rolename: "ERP-Settings_Automation",
  },
  {
    text: "Account Settings",
    icon: <img src={chartPic} alt="Reports" className="ml-3 Iconpayable" />,
    url: "/settings/account-settings",
    rolename: "ERP-Profile_Business Profile",
    route: "account-settings",
  },

  // {
  //   text: "Revert Vouchers",
  //   icon: (
  //     <img
  //       src={ledgerPic}
  //       alt="revert-back-vouchers"
  //       className="ml-3 Icondashboard"
  //     />
  //   ),
  //   url: "/settings/revert-back-vouchers",
  //   rolename: "Settings_Revert Back Vouchers",
  // },
];

export const revertVouchers = [
  {
    text: "Revert Vouchers",
    icon: <img src={dashboardPic} alt="revert-back-vouchers" className="ml-3 Icondashboard" />,
    url: "/settings/revert-back-vouchers",
    rolename: "Settings_Revert Back Vouchers",
  },
];
export const Roles = [
  {
    text: "Roles",
    icon: <img src={dashboardPic} alt="Roles" className="ml-3 Icondashboard" />,
    url: "/settings/roles",
    rolename: "Settings_Roles",
  },
];
export const Tags = [
  {
    text: "Tags",
    icon: <img src={todolist} alt="tags" className="ml-3 Icondashboard" />,
    url: "/settings/tags",
    rolename: "Settings_Tags",
  },
];
export const Users = [
  {
    text: "Users",
    icon: <img src={dashboardPic} alt="Users" className="ml-3 Icondashboard" />,
    url: "/settings/users",
    rolename: "Settings_Users",
  },
];
export const ChangeRequest = [
  {
    text: "Change Request",
    icon: <img src={dashboardPic} alt="ChangeRequest" className="ml-3 Icondashboard" />,
    url: "/settings/change-request",
    rolename: "Settings_Change Request",
  },
];
export const WhatsApp = [
  {
    url: "/settings/whatsapp/instances",
    text: "WhatsApp",
    icon: <img src={whatsupPic} alt="WhatsApp" className="ml-3 Icondashboard" />,
    rolename: "Settings_WhatsApp",
  },
];

export const operationsArray = [
  {
    text: "Dashboard",
    icon: <img src={dashboardPic} alt="Dashboard" className="ml-3 Icondashboard" />,
    url: "/store/dashboard",
    rolename: "Store Dashboard_View",
  },
  {
    text: "Material Req.",
    route: "material-requisition",
    icon: <img src={taskPic} alt="Material Req." className="ml-3 Icondashboard" />,
    rolename: "Store Dashboard_View",
    url: "/store/material-requisition",
  },
  {
    text: "Material",
    icon: <img src={availablePic} alt="Material" className="ml-3 Icondashboard" />,
    rolename: "Store Dashboard_View",
    url: "/store/material",
    route: "material",
  },
  {
    text: "Stock",
    icon: <img src={availablePic} alt="Stock" className="ml-3 Icondashboard" />,
    rolename: "Store Dashboard_View",
    url: "/store/stock",
  },
  {
    text: "Requisition",
    icon: <img src={taskPic} alt="Purchase Requisition" className="ml-3 Icondashboard" />,
    rolename: "Store Dashboard_View",
    url: "/store/purchase-requisitions",
  },
  {
    text: "Configuration",
    icon: <img src={assestsPic} alt="Configuration" className="ml-3 Icondashboard" />,
    rolename: "Store Dashboard_View",
    url: "/store/configuration/category",
    subbtn: [
      {
        text: "Category",
        url: "/store/configuration/category",
        rolename: "Store Dashboard_View",
      },
      {
        text: "UOM",
        url: "/store/configuration/uom",
        rolename: "Store Dashboard_View",
      },
    ],
  },
  {
    text: "Outward Pass",
    route: "gate-pass",
    icon: <img src={taskPic} alt="Gate Pass" className="ml-3 Icondashboard" />,
    rolename: "Store Dashboard_View",
    url: "/store/gate-pass",
  },
  {
    text: "Reports",
    icon: <img src={reportPic} alt="Reports" className="ml-3 Icondashboard" />,
    url: "/store/report/stock-report",
    route: "stock-report",
    rolename: "Store Dashboard_View",
    subbtn: [
      {
        text: "Stock Report",
        url: "/store/report/stock-report",
        rolename: "Store Dashboard_View",
      },
      {
        text: "Stock Balance & Valuation",
        url: "/store/reports/stock-valuation",
        route: "stock-valuation",
        rolename: "Store Dashboard_View",
      },
      {
        text: "BOQ Consumption vs Limit",
        url: "/store/reports/boq-consumption",
        route: "boq-consumption",
        rolename: "Store Dashboard_View",
      },
      {
        text: "GRN Register",
        url: "/store/reports/grn-register",
        route: "grn-register",
        rolename: "Store Dashboard_View",
      },
      {
        text: "Material Issue Register",
        url: "/store/reports/min-register",
        route: "min-register",
        rolename: "Store Dashboard_View",
      },
      {
        text: "Inter-Site Transfers",
        url: "/store/reports/inter-site-transfers",
        route: "inter-site-transfers",
        rolename: "Store Dashboard_View",
      },
      {
        text: "Critical Stock & Reorder",
        url: "/store/reports/reorder-alerts",
        route: "reorder-alerts",
        rolename: "Store Dashboard_View",
      },
    ],
  },
];

// Procurement navigation.
export const procurementArray = [
  {
    text: "Dashboard",
    icon: <img src={dashboardPic} alt="Dashboard" className="ml-3 Icondashboard" />,
    url: "/procurement/dashboard",
    route: "dashboard",
    rolename: "Store Dashboard_View",
  },
  {
    text: "Purchase Requisition",
    route: "purchase-requisition",
    icon: <img src={taskPic} alt="Purchase Requisition" className="ml-3 Icondashboard" />,
    rolename: "Store Dashboard_View",
    url: "/procurement/purchase-requisition",
  },
  {
    text: "Quotation",
    route: "quotations",
    icon: <img src={todolist} alt="Quotation" className="ml-3 Icondashboard" />,
    rolename: "Store Dashboard_View",
    url: "/procurement/quotations/quotes",
    subbtn: [
      {
        text: "Quotes",
        url: "/procurement/quotations/quotes",
        rolename: "Store Dashboard_View",
        route: "quotes",
      },
      {
        text: "Quotes Comparison",
        url: "/procurement/quotations/comparison",
        rolename: "Store Dashboard_View",
        route: "comparison",
      },
    ],
  },
  {
    text: "Vendors",
    icon: <img src={assestsPic} alt="Vendors" className="ml-3 Icondashboard" />,
    rolename: "Store Dashboard_View",
    url: "/procurement/vendors",
    route: "/procurement/vendors",
  },
  {
    text: "Purchase Ord.",
    icon: <img src={taskPic} alt="Purchase Orders" className="ml-3 Icondashboard" />,
    rolename: "Store Dashboard_View",
    url: "/procurement/purchase-order",
    route: "purchase-order",
  },
  {
    text: "GRN",
    icon: <img src={taskPic} alt="GRN" className="ml-3 Icondashboard" />,
    rolename: "Store Dashboard_View",
    url: "/procurement/GRN",
    route: "grn",
  },
  {
    text: "Purchase Inv.",
    route: "/procurement/purchase-invoice",
    icon: <img src={ledgerPic} alt="Invoice" className="ml-3 Icondashboard" />,
    rolename: "Store Dashboard_View",
    url: "/procurement/purchase-invoice",
  },
  {
    text: "Reports",
    icon: <img src={reportPic} alt="Reports" className="ml-3 Icondashboard" />,
    url: "/procurement/reports/po-fulfillment",
    route: "reports",
    rolename: "Store Dashboard_View",
    subbtn: [
      {
        text: "PO Register & Fulfillment",
        url: "/procurement/reports/po-fulfillment",
        route: "po-fulfillment",
        rolename: "Store Dashboard_View",
      },
      {
        text: "PR to PO Conversion",
        url: "/procurement/reports/pr-conversion",
        route: "pr-conversion",
        rolename: "Store Dashboard_View",
      },
      {
        text: "3-Way Audit",
        url: "/procurement/reports/three-way-match",
        route: "three-way-match",
        rolename: "Store Dashboard_View",
      },
      {
        text: "Payment Aging",
        url: "/procurement/reports/vendor-aging",
        route: "vendor-aging",
        rolename: "Store Dashboard_View",
      },
      {
        text: "Spend Analysis",
        url: "/procurement/reports/procurement-spend",
        route: "procurement-spend",
        rolename: "Store Dashboard_View",
      },
      {
        text: "Vendor Performance",
        url: "/procurement/reports/vendor-performance",
        route: "vendor-performance",
        rolename: "Store Dashboard_View",
      },
    ],
  },
];

// Works navigation. Dedicated screens for the workflow areas will be added in
// later phases; the URLs are established now without changing permissions.
export const worksArray = [
  {
    text: "Dashboard",
    icon: <img src={dashboardPic} alt="Dashboard" className="ml-3 Icondashboard" />,
    url: "/works/dashboard",
    // TODO: Replace this temporary permission with a dedicated Works dashboard role.
    rolename: "Store Work Orders_View",
  },
  {
    text: "Contractors",
    icon: <img src={personPic} alt="Contractors" className="ml-3 Icondashboard" />,
    url: "/works/contractors",
    rolename: "Store Contractors_View",
  },
  {
    text: "Bill of Quantities",
    icon: <img src={projectPic} alt="Bill of Quantities" className="ml-3 Icondashboard" />,
    url: "/works/bill-of-quantities",
    route: "bill-of-quantities",
    rolename: "Store Contractors_View",
  },
  {
    text: "Rate Library",
    icon: <img src={ledgerPic} alt="Rate Library" className="ml-3 Icondashboard" />,
    url: "/works/rate-library",
    route: "rate-library",
    rolename: "Store Contractors_View",
  },
  {
    text: "Work Orders",
    icon: <img src={projectPic} alt="Work Orders" className="ml-3 Icondashboard" />,
    url: "/works/work-orders",
    route: "work-orders",
    rolename: "Store Work Orders_View",
  },
  {
    text: "Contractor Bills",
    icon: <img src={ledgerPic} alt="Contractor Bills" className="ml-3 Icondashboard" />,
    url: "/works/contractor-bills",
    route: "contractor-bills",
    rolename: "Store Work Orders_View",
  },
  {
    text: "M-Book",
    icon: <img src={taskPic} alt="M-Book" className="ml-3 Icondashboard" />,
    url: "/works/measurement-book",
    route: "measurement-book",
    rolename: "Store Work Orders_View",
  },
  {
    text: "Reports",
    icon: <img src={reportPic} alt="Reports" className="ml-3 Icondashboard" />,
    url: "/works/reports/wo-progress",
    route: "reports",
    rolename: "Store Dashboard_View",
    subbtn: [
      {
        text: "WO Progress",
        url: "/works/reports/wo-progress",
        route: "wo-progress",
        rolename: "Store Dashboard_View",
      },
      {
        text: "Contractor RA",
        url: "/works/reports/ra-bills",
        route: "ra-bills",
        rolename: "Store Dashboard_View",
      },
      {
        text: "MB Quantity Audit",
        url: "/works/reports/mb-audit",
        route: "mb-audit",
        rolename: "Store Dashboard_View",
      },
      {
        text: "Retention Money Ledger",
        url: "/works/reports/retention-ledger",
        route: "retention-ledger",
        rolename: "Store Dashboard_View",
      },
      {
        text: "Advance Recovery",
        url: "/works/reports/advance-recovery",
        route: "advance-recovery",
        rolename: "Store Dashboard_View",
      },
      {
        text: "Payables Aging",
        url: "/works/reports/contractor-aging",
        route: "contractor-aging",
        rolename: "Store Dashboard_View",
      },
    ],
  },
];

// Client Work navigation
export const clientWorkArray = [
  {
    text: "Dashboard",
    icon: <img src={dashboardPic} alt="Dashboard" className="ml-3 Icondashboard" />,
    url: "/client-work/dashboard",
    route: "dashboard",
    rolename: "Store Work Orders_View",
  },
  {
    text: "Clients",
    icon: <img src={personPic} alt="Clients" className="ml-3 Icondashboard" />,
    url: "/client-work/clients",
    route: "clients",
    rolename: "Store Work Orders_View",
  },
  {
    text: "Contracts",
    icon: <img src={ledgerPic} alt="Contracts" className="ml-3 Icondashboard" />,
    url: "/client-work/contracts",
    route: "contracts",
    rolename: "Store Work Orders_View",
  },
  {
    text: "Invoices",
    icon: <img src={payrollPic} alt="Invoices" className="ml-3 Icondashboard" />,
    url: "/client-work/invoices",
    route: "invoices",
    rolename: "Store Work Orders_View",
  },
  {
    text: "Reports",
    icon: <img src={reportPic} alt="Reports" className="ml-3 Icondashboard" />,
    url: "/client-work/reports/contract-billing-abstract",
    route: "reports",
    rolename: "Store Dashboard_View",
    subbtn: [
      {
        text: "Billing Abstract",
        url: "/client-work/reports/contract-billing-abstract",
        route: "contract-billing-abstract",
        rolename: "Store Dashboard_View",
      },
      {
        text: "Retention Ledger",
        url: "/client-work/reports/retention-ledger",
        route: "retention-ledger",
        rolename: "Store Dashboard_View",
      },
      {
        text: "Mobilization Advance",
        url: "/client-work/reports/mobilization-advance",
        route: "mobilization-advance",
        rolename: "Store Dashboard_View",
      },
      {
        text: "AR Aging",
        url: "/client-work/reports/ar-aging",
        route: "ar-aging",
        rolename: "Store Dashboard_View",
      },
    ],
  },
];


export const commissionArray = [
  {
    text: "Dashboard",
    icon: <img src={dashboardPic} alt="Dashboard" className="ml-3 mr-1 Icondashboard" />,
    url: "/commission/dashboard",
    rolename: "Accounts_Dashboard",
  },
  {
    text: "Developers",
    icon: <img src={projectPic} alt="Developers" className="ml-3 mr-1 Icondashboard" />,
    url: "/commission/developers",
    rolename: "Accounts_Dashboard",
  },
  {
    text: "Aging",
    icon: <img src={ledgerPic} alt="Aging" className="ml-3 mr-1 Iconpayable" />,
    url: "/commission/aging",
    rolename: "Accounts_Dashboard",
  },
  {
    text: "Lifecycle",
    icon: <img src={chartPic} alt="Lifecycle" className="ml-3 mr-1 Iconpayable" />,
    url: "/commission/lifecycle",
    rolename: "Accounts_Dashboard",
  },
  {
    text: "Payouts",
    icon: <img src={payrollPic} alt="Payouts" className="ml-3 mr-1 Iconpayable" />,
    url: "/commission/payouts",
    rolename: "Accounts_Dashboard",
  },
  {
    text: "Reconciliation",
    icon: <img src={taxPic} alt="Reconciliation" className="ml-3 mr-1 Iconpayable" />,
    url: "/commission/reconciliation",
    rolename: "Accounts_Dashboard",
  },
  {
    text: "Branches",
    icon: <img src={homePic} alt="Branches" className="ml-3 mr-1 Iconhome" />,
    url: "/commission/branches",
    rolename: "Accounts_Dashboard",
  },
  {
    text: "Audit Trail",
    icon: <img src={reportPic} alt="Audit" className="ml-3 mr-1 Iconpayable" />,
    url: "/commission/audit",
    rolename: "Accounts_Dashboard",
  },
];
